export default __webpack_public_path__ + "static/media/backarrow.4857a587.svg";